import { fetcher } from '#lib/backendFetcher';

/**
 * Starts a unified search (Maps or HR) via the unified endpoint.
 * @param {Object} params
 * @param {string} params.queryName - Name for the prospect query
 * @param {"maps"|"hr"} params.searchType - Search type
 * @param {Object} params.searchParameters - Search parameters (varies by type)
 * @returns {Promise<{status: string, jobId: string, prospectQueryId: string, searchType: string}>}
 */
export const invokeUnifiedSearch = async ({ queryName, searchType, searchParameters }) => {
	return await fetcher('/api/v1/search/unified/startSearch', {
		method: 'POST',
		body: {
			queryName,
			searchType,
			searchParameters,
		},
	});
};
